<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-btn icon dark @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>{{
        $t('message.delayNotification.header')
      }}</v-toolbar-title>
    </v-toolbar>
    <v-container>
      <v-row>
        <v-select
          v-model="selectedDelay"
          :label="$t('message.delayNotification.selectMinutes')"
          prepend-icon="mdi-timer"
          :items="delayOptions"
        >
        </v-select>
      </v-row>
      <v-row>
        <v-btn
          id="sendDelayButton"
          @click="sendDelayNotification(selectedDelay)"
        >
          {{ $t('message.delayNotification.send') }}
          <v-icon right>mdi-send</v-icon>
        </v-btn>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    selectedDelay: 5,
    delayOptions: [5, 10, 15, 20]
  }),
  props: {
    closeDialog: { type: Function },
    sendDelayNotification: { type: Function }
  }
};
</script>

<style>
#sendDelayButton {
  margin: auto;
}
</style>
